<template>
  <div id="countdown">
    <h1>Countdown To The Election</h1>
    <div id="clockdiv">
      <div id="clockdiv_days_block">
        <span class="days">{{ days }}</span>
        <div class="smalltext">Days</div>
      </div>
      <div>
        <span class="hours">{{ hours | pad_zeros }}</span>
        <div class="smalltext">Hours</div>
      </div>
      <div>
        <span>:</span>
        <span class="minutes">{{ minutes | pad_zeros }}</span>
        <div class="smalltext">Minutes</div>
      </div>
      <div>
        <span>:</span>
        <span class="seconds">{{ seconds | pad_zeros }}</span>
        <div class="smalltext">Seconds</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CountdownClock",
  data() {
    return {
      days: 30,
      hours: 0,
      minutes: 0,
      seconds: 0,
      clockInterval: null,
      election_day: new Date(2020, 10, 3)
    };
  },
  filters: {
    pad_zeros: function(value) {
      if (!value) return "00";
      value = value.toString();
      return `00${value}`.slice(-2);
    }
  },
  methods: {
    updateClock() {
      /* COUNTDOWN TIMER from
       * https://www.sitepoint.com/build-javascript-countdown-timer-no-dependencies/
       */
      //NOTE: date initializatin uses month numbers starting with zero!
      const total = Date.parse(this.election_day) - Date.parse(new Date());
      if (total > 0) {
        this.seconds = Math.floor((total / 1000) % 60);
        this.minutes = Math.floor((total / 1000 / 60) % 60);
        this.hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        this.days = Math.floor(total / (1000 * 60 * 60 * 24));
      } else {
      // Election Day Update:
        this.seconds = 0;
        this.minutes = 0;
        this.hours = 0;
        this.days = 0;
      }
    },
    start_clock() {
      this.clockInterval = setInterval(this.updateClock, 1000);
    },
    stop_clock() {
      clearInterval(this.clockInterval);
    }
  },
  created() {
    this.start_clock();
  }
};
</script>

<style scoped>
/* COUNTDOWN TIMER */
#countdown {
  position: relative;
  font-family: "Montserrat", sans-serif;
  text-transform: uppercase;
  text-align: center;
  background: black;
  color: white;
  font-weight: lighter;
  width: 100%;
}

#countdown h1 {
  font-size: 0.95rem;
  margin: 0;
  padding: 0;
  padding-top: 0.4rem;
}

#clockdiv {
  margin: 0;
  padding: 0;
  width: 100%;
  min-width: 256px;
  white-space: nowrap;
  overflow-y: hidden;
  text-transform: capitalize;
  font-family: "Montserrat", sans-serif;
  color: #fff;
  display: inline-block;
  font-weight: 100;
  text-align: center;
  font-size: 1.7rem;
}

#clockdiv > div {
  display: inline-block;
}

#clockdiv div > span {
  display: inline-block;
  font-size: 2.5rem;
}

#clockdiv div > span.seconds {
  min-width: 3.5rem;
}

#clockdiv_days_block {
  color: #00ff00;
  margin-right: 30px;
}

.smalltext {
  padding-top: 5px;
  font-size: 0.35rem;
  text-transform: uppercase;
}
</style>